<script setup>
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { computed } from "vue";

const props = defineProps({
  class: { type: String, default: "" },
  animation: { type: String, default: "fade-up" },
  delay: { type: Number, default: 0 },
  duration: { type: Number, default: 600 },
  threshold: { type: Number, default: 0.1 },
});

const { elementRef, isVisible } = useScrollAnimation({ threshold: props.threshold });

const animationClasses = {
  "fade-up": {
    initial: "opacity-0 translate-y-8",
    visible: "opacity-100 translate-y-0",
  },
  "fade-down": {
    initial: "opacity-0 -translate-y-8",
    visible: "opacity-100 translate-y-0",
  },
  "fade-left": {
    initial: "opacity-0 translate-x-8",
    visible: "opacity-100 translate-x-0",
  },
  "fade-right": {
    initial: "opacity-0 -translate-x-8",
    visible: "opacity-100 translate-x-0",
  },
  scale: {
    initial: "opacity-0 scale-95",
    visible: "opacity-100 scale-100",
  },
  fade: {
    initial: "opacity-0",
    visible: "opacity-100",
  },
};

const currentAnimation = computed(() => animationClasses[props.animation] || animationClasses["fade-up"]);
</script>

<template>
  <div
    ref="elementRef"
    :class="cn(
      'transition-all ease-out',
      isVisible ? currentAnimation.visible : currentAnimation.initial,
      props.class
    )"
    :style="{
      transitionDuration: `${duration}ms`,
      transitionDelay: `${delay}ms`,
    }"
  >
    <slot />
  </div>
</template>
